<template>
  <v-card class="pa-5">
    <div class="text-overline grey--text text--darken-2" style="line-height: 1.4">Vista previa</div>
    <div class="text-caption grey--text text--darken-1 mb-3">Así se verá en el organigrama</div>

    <div class="oc-preview">
      <template v-if="parent">
        <div class="oc-node" :class="nodeClasses(parent)" style="height: 48px">
          <div class="oc-node-text text-center w-100">
            <div class="oc-node-name">{{ parent.name }}</div>
          </div>
        </div>
        <div class="oc-preview-parent-line"></div>
      </template>

      <div class="oc-subtree">
        <div class="oc-node oc-node--selected" :class="nodeClasses(item)">
          <div v-if="item.legajo" class="oc-avatar">{{ initials(item.legajo) }}</div>
          <div v-else class="oc-avatar oc-avatar--vacant">+</div>
          <div class="oc-node-text">
            <div class="oc-node-name">{{ item.name || "Nuevo puesto" }}</div>
            <div v-if="item.legajo" class="oc-node-detail">{{ item.legajo.name }} {{ item.legajo.surname }}</div>
            <div v-else class="oc-node-detail oc-vacant-label">Vacante</div>
          </div>
        </div>

        <div v-if="children.length > 0" class="oc-children-v">
          <div v-for="child in children" :key="child.id" class="oc-branch">
            <div class="oc-node" :class="nodeClasses(child)">
              <div class="oc-node-text">
                <div class="oc-node-name">{{ child.name }}</div>
                <div v-if="child.legajo" class="oc-node-detail">{{ child.legajo.name }} {{ child.legajo.surname }}</div>
                <div v-else class="oc-node-detail oc-vacant-label">Vacante</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="text-caption grey--text text--darken-1 mt-6 mb-0">Al cambiar «Depende de», el puesto se mueve junto con todos sus dependientes.</p>
  </v-card>
</template>

<script>
import { NODE_STYLE_LIGHT } from "@/constants/org_chart";

export default {
  name: "CardPreview",
  props: {
    item: Object,
    // Puesto superior completo (con tipo y responsable)
    parent: Object,
    children: { type: Array, default: () => [] },
  },
  methods: {
    initials(legajo) {
      return ((legajo.name || "").charAt(0) + (legajo.surname || "").charAt(0)).toUpperCase();
    },
    nodeClasses(node) {
      const style = node.node_type != null ? node.node_type.style : NODE_STYLE_LIGHT;
      return {
        ["oc-node--" + style]: true,
        "oc-node--vacant": node.legajo == null,
        "oc-node--disabled": node.enabled === false,
      };
    },
  },
};
</script>
